import { type AddToShipmentEndpointAddToShipmentRequest } from '@alto/scriptdash/alto/patient_app/scheduling/v1/add_to_shipment_endpoint';
import { createQueryKeys } from '@lukemorales/query-key-factory';

export const addToShipment = createQueryKeys('addToShipment', {
  addToShipment: (params: AddToShipmentEndpointAddToShipmentRequest) => ({
    queryKey: [params],
  }),
});
